var module = angular.module('octopusApp.master', []);



//////////////////
// WEBPACK FOOTER
// ./app/areas/master/master_module.js
// module id = 134
// module chunks = 1